module.exports = __webpack_public_path__ + "img/placeholder.7636e3da.svg";